import { v4 as uuidv4 } from 'uuid';
import { Wishlist } from '../../../../vtex-apps/peer/wishlist/Wishlist/default';
import { StackLayout } from '../../../../vtex-apps/stack-layout/StackLayout/default';
import { ProductSummaryName } from '../../../../vtex-apps/product-summary/ProductSummaryName/default';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ProductListPrice } from '../../../../vtex-apps/product-price/ProductListPrice/default';

import { ProductInstallments } from '../../../../vtex-apps/product-price/ProductInstallments/default';
import { AddToCartButton } from '../../../../vtex-apps/add-to-cart-button/AddToCartButton/default';
import { ProductHighlights } from '../../../../vtex-apps/product-highlights/ProductHighlights/default';
import { ProductSummaryImage } from '../../../../vtex-apps/product-summary/ProductSummaryImage/default';
import { ProductBrand } from '../../../../vtex-apps/store-components/ProductBrand/default';
import { ProductRatingInline } from '../../../../vtex-apps/peer/reviews-and-ratings/ProductRatingInline/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { ProductSpotPrice } from '../../../../vtex-apps/product-price/ProductSpotPrice/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { ConditionLayoutProduct } from '../../../../vtex-apps/ConditionLayoutProduct/default';
import { ProductSummarySkuSelector } from '../../../../vtex-apps/product-summary/ProductSummarySkuSelector/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function ProductSummaryShelf() {
	return {
		componentName: 'ProductSummaryShelfComponent',
		componentId: uuidv4(),
		componentGroup: 'ProductSummaryShelf',
		variables,
		props: {
			blockClass: 'product-list__summary-1',
		},
		childrenComponents: [
			Wishlist({ blockClass: 'product-shelf__wishlist-1' }),
			FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-shelf__row-1' }, [
				ConditionLayoutProduct({
					conditions: [{ subject: 'isProductAvailable' }],
					Then: StackLayout(
						{
							blockClass: 'product-list__shelf-1',
						},
						[
							ProductSummaryImage({ blockClass: 'product-list__image-1', maxHeight: 500 }),
							FlexLayoutRow({ blockClass: 'row-sku__shelf-1', marginTop: 3, marginBottom: 3 }, [
								ProductSummarySkuSelector({ blockClass: 'sku-selector__shelf-1' }),
								AddToCartButton({
									unavailableText: 'Indisponível',
									text: 'Ver Detalhes',
									blockClass: 'summary__add-to-cart-btn',
									onClickBehavior: 'go-to-product-page',
								}),
							]),
							ProductHighlights({ blockClass: 'product-list-1' }),
						],
					),
					Else: StackLayout({ blockClass: 'product-list-unavailable__shelf-1' }, [
						ProductSummaryImage({ blockClass: 'product-list-unavailable__image-1', maxHeight: 500 }),
						FlexLayoutRow({ blockClass: 'row-sku__shelf-1', marginTop: 3, marginBottom: 3 }, [
							AddToCartButton({
								mzIsUnavailable: true,
								unavailableText: 'Indisponível',
								blockClass: 'shelf-btn-unavailable__shelf-1',
								onClickBehavior: 'go-to-product-page',
							}),
						]),
						ProductHighlights({ blockClass: 'product-list-1' }),
					]),
				}),
				FlexLayoutRow(
					{ blockClass: 'shelf__product-name-wrapper-1', colSizing: 'auto', preserveLayoutOnMobile: true },
					[
						ProductSummaryName({
							blockClass: 'product-summary__name-1',
							showFieldsProps: {
								showSku: false,
								showProductReference: false,
								showBrandName: true,
							},
						}),
						VisibilityLayout({ mzTitle: 'MZ | Mostrar marca (On/Off)' }, [
							ProductBrand({ blockClass: 'shelf__product-brand-1', height: 32 }),
						]),
					],
				),
				VisibilityLayout({ mzTitle: 'MZ | Mostrar avaliação (On/Off)' }, [ProductRatingInline()]),
				FlexLayoutRow(
					{
						blockClass: 'shelf__flex-row-1',
						colSizing: 'auto',
						horizontalAlign: 'left',
						colGap: 2,
					},
					[
						ProductListPrice({
							blockClass: 'product-shelf__list-price-1',
							alwaysShow: true,
						}),
						ProductSpotPrice({
							blockClass: 'product-shelf__selling-price-1',
							alwaysShow: true,
						}),
					],
				),

				// ProductInstallments({
				//     blockClass: 'product-shelf__installments-1'
				// }),
				RichText({ blockClass: 'product-price-info__shelf-1', text: 'à vista no boleto, depósito ou pix' }),
				ConditionLayoutProduct({
					conditions: [{ subject: 'isProductAvailable' }],
					Then: FlexLayoutRow(
						{
							blockClass: 'flex-row-other-installment__shelf-1',
							colSizing: 'auto',
							colGap: 3,
							preserveLayoutOnMobile: true,
							marginTop: 3,
						},
						[
							Image({
								blockClass: 'other-installment__shelf-1',
								src: 'https://hefesto-upload-images.s3.amazonaws.com/1667253738000-card-shelf-icon.png',
							}),
							ProductInstallments({
								blockClass: 'other-installment-value__shelf-1',
								installmentsCriteria: 'max-quantity-without-interest',
								markers: ['bold'],
								message: 'ou <bold> {installmentsNumber}x de {installmentValue}</bold> no crédito ',
							}),
						],
					),
					Else: null,
				}),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--cta-color-pure', to: '--shelf-1-highlight-color', name: 'Highlight' },
			{ from: '--white', to: '--shelf-1-highlight-text-color', name: 'Highlight Text' },
			{ from: '--text-color-1', to: '--shelf-1-text-color', name: 'Text' },
			{ from: '--neutral-color-high-medium', to: '--shelf-1-border-color', name: 'Shelf Border' },
			{ from: '--brand-color-primary-pure', to: '--shelf-1-border-color-active', name: 'Shelf Border Active' },
			{ from: '--text-color-1', to: '--shelf-1-installments-color', name: 'Installments' },
			{ from: '--text-color-1', to: '--shelf-1-installments-value-color', name: 'Installments Value' },
			{ from: '--text-color-1-light', to: '--shelf-1-list-price-color', name: 'List Price' },
			{ from: '--text-color-1', to: '--shelf-1-price-color', name: 'SellingPrice' },
			{ from: '--brand-color-primary-pure', to: '--shelf-1-reviews-color', name: 'Reviews' },
			{ from: '--white', to: '--shelf-1-text-cta-color', name: 'CTA Text' },
			{ from: '--cta-color-pure', to: '--shelf-1-cta-color', name: 'CTA' },
			{ from: '--cta-color-hover', to: '--shelf-1-cta-color-hover', name: 'CTA Hover' },
			{ from: '--cta-color-focus', to: '--shelf-1-cta-color-focus', name: 'CTA Focus' },
			{ from: '--brand-color-primary-pure', to: '--shelf-1-sku-detail-color', name: 'SKU Selector' },
			{ from: '--brand-color-primary-pure', to: '--shelf-1-sku-text-color', name: 'SKU Selector Text' },
			{ from: '--brand-color-primary-pure', to: '--shelf-1-pix-text-color', name: 'Boleto pix' },
			{ from: '--white', to: '--shelf-1-badge-text', name: 'Discount badge text' },
			{ from: '--brand-color-primary-pure', to: '--shelf-1-badge-background', name: 'Discount badge background' },

			{ from: '--brand-color-primary-pure', to: '--shelf-1-wishlist', name: 'wishlist icon' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--shelf-1-border-radius', name: 'Shelf' },
			{ from: '--border-radius-sm', to: '--shelf-1-cta-border-radius', name: 'CTA' },
			{ from: '--border-radius-none', to: '--shelf-1-highlight-border-radius', name: 'Highlight' },
			{ from: '--border-radius-none', to: '--shelf-1-details-br', name: 'Details' },
			{ from: '--border-radius-none', to: '--shelf-1-sku-br', name: 'SKU Selector' },
		],
	},
	{
		type: 'borderWidth',
		list: [{ from: '--border-width-hairline', to: '--shelf-1-border-width', name: 'Shelf' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxxs', to: '--shelf-1-highlight-font-size', name: 'Highlight' },
			{ from: '--font-size-xs', to: '--shelf-1-name-font-size', name: 'Product Name' },
			{ from: '--font-size-lg', to: '--shelf-1-reviews-font-size', name: 'Reviews Stars' },
			{ from: '--font-size-sm', to: '--shelf-1-list-font-size', name: 'List Price' },
			{ from: '--font-size-lg', to: '--shelf-1-selling-font-size', name: 'Selling Price' },
			{ from: '--font-size-sm', to: '--shelf-1-installments-font-size', name: 'Installments Text' },
			{ from: '--font-size-xs', to: '--shelf-1-installments-value-font-size', name: 'Installments Values' },
			{ from: '--font-size-sm', to: '--shelf-1-cta-font-size', name: 'CTA' },
			{ from: '--font-size-sm', to: '--shelf-1-sku-fs', name: 'SKU Selector' },
			{ from: '--font-size-sm', to: '--shelf-1-pix-fs', name: 'Boleto pix' },
			{ from: '--font-size-xxxs', to: '--shelf-1-badge-fs', name: 'Discount badge text' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--shelf-1-hightlight-fw', name: 'Highlight' },
			{ from: '--font-weight-700', to: '--shelf-1-name-fw', name: 'Product Name' },
			{ from: '--font-weight-400', to: '--shelf-1-list-fw', name: 'List Price' },
			{ from: '--font-weight-400', to: '--shelf-1-selling-fw', name: 'Selling Price' },
			{ from: '--font-weight-400', to: '--shelf-1-installments-fw', name: 'Installments Text' },
			{ from: '--font-weight-700', to: '--shelf-1-installments-value-fw', name: 'Installments Values' },
			{ from: '--font-weight-700', to: '--shelf-1-cta-fw', name: 'CTA' },
			{ from: '--font-weight-700', to: '--shelf-1-sku-fw', name: 'SKU Selector' },
			{ from: '--font-weight-700', to: '--shelf-1-pix-fw', name: 'Boleto pix' },
			{ from: '--font-weight-300', to: '--shelf-1-badge-fw', name: 'Discount badge text' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--shelf-1-highlight-typography', name: 'Highlight' },
			{ from: '--main-font', to: '--shelf-1-name-typography', name: 'Product Name' },
			{ from: '--main-font', to: '--shelf-1-list-typography', name: 'List Price' },
			{ from: '--main-font', to: '--shelf-1-selling-typography', name: 'Selling Price' },
			{ from: '--main-font', to: '--shelf-1-installments-typography', name: 'Installments' },
			{ from: '--main-font', to: '--shelf-1-cta-typography', name: 'CTA' },
			{ from: '--main-font', to: '--shelf-1-sku-typography', name: 'SKU Selector' },
			{ from: '--main-font', to: '--shelf-1-pix-typography', name: 'Boleto pix' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxxs', to: '--shelf-1-lateral-spacing', name: 'Lateral Padding' },
			{ from: '--spacing-nano', to: '--shelf-1-cta-spacing', name: 'CTA Height' },
			{ from: '--spacing-nano', to: '--shelf-1-highlight-spacing', name: 'Highlight Height' },
			{ from: '--spacing-nano', to: '--shelf-1-highlight-vp', name: 'Highlight Vertical Padding' },
			{ from: '--spacing-sm', to: '--shelf-1-sku-width', name: 'SKU Width' },
			{ from: '--spacing-sm', to: '--shelf-1-sku-height', name: 'SKU Height' },
		],
	},
];
